import type { JSX, ParentComponent } from "solid-js";
import extendedLogo from "@/assets/extended-light-logo.svg";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { Container } from "../shared/Container";

export const OnboardingLayout: ParentComponent<{
  metaTitle: string;
  /**
   * Rendered flush against the bottom edge of the fixed header — the slot for a
   * flow's progress bar.
   *
   * It lives here rather than in the scrolling content because that is the only
   * way it can be *attached* to anything: the header is `fixed`, so a bar drawn
   * below it hangs over the page background at whatever offset the content
   * happens to use, and scrolls away the moment the page is taller than the
   * viewport. Inside the header it is flush by construction, and its track is
   * finally legible — against the page background `bg-gray-100` is invisible.
   */
  headerAccessory?: JSX.Element;
}> = (props) => {
  return (
    <div class="h-screen flex flex-col justify-between relative">
      <MetaTitleWithSeparator>{props.metaTitle}</MetaTitleWithSeparator>
      <div
        data-onboarding-header
        class="w-full border-b border-gray-200 bg-white fixed top-0 left-0 right-0 z-10"
      >
        <Container size="6xl" class="mx-auto text-xl font-medium py-4">
          <img
            src={extendedLogo}
            alt="Sevedemo logo"
            class="w-auto h-8 block md:hidden"
          />
          <img
            src={extendedLogo}
            alt="Sevedemo logo"
            class="w-auto h-6 hidden md:block"
          />
        </Container>
        {props.headerAccessory}
      </div>
      {props.children}
    </div>
  );
};
